export default "__VITE_ASSET__BZSvLSa3__"